import { getReferralLinkBase } from '@podus/utils';

/**
 * Build an ambassador's referral link for the *current* environment.
 *
 * The API also returns an absolute `referralLink`, but it is built from the
 * server's `AB_REFERRAL_LINK_BASE` (default `https://podus.ai/ab`) — correct for
 * outbound email, wrong for a dev dashboard, which would show a production URL
 * that can't be clicked through locally.
 *
 * Deriving from the code instead means the link always points at the podus.ai
 * this build talks to: `localhost:3010/ab/{code}` in dev, `podus.ai/ab/{code}`
 * in production. `/ab/:code` is a podus.ai route — it exists on no other app.
 */
export function referralLinkFor(code: string): string {
    return `${getReferralLinkBase().replace(/\/$/, '')}/${code}`;
}
